import { PumpSizing } from "./components/PumpSizing";

function App() {
	return (
		<div className="pump-sizing-app">
			<PumpSizing />
		</div>
	);
}

export default App;
